import { useState, useContext } from "react";
import { ShareContext } from "../../context/ShareContext";
import wordicon from "../../assets/ms_word.png";
import excelicon from "../../assets/ms_excel.png";
import pdficon from "../../assets/pdf.png";
import CustomSearchSortHeader from "../../components/core/CustomSearchSortHeader";
import JisButton from "../../components/controls/jisButton";
import Pagenated from "../../components/pagenated";
import JisEmptyList from "../../components/controls/emptylist";
import { displayDate } from "../../constants";

const judgePostJudgementCases = [
  {
    id: 1,
    suitNumber: "ID/3885GCM/2025",
    caseTitle: "State of Lagos vs Salman Lukman",
    type: "Writ of fifa",
    judgementDate: "12 Sept, 2025",
    statusLevel: "Reviewed by ACR",
    caseCategoryId: 1,
  },
  {
    id: 2,
    suitNumber: "ID/3885GCM/2025",
    caseTitle: "State of Lagos vs Salman Lukman",
    type: "Writ of fifa",
    judgementDate: "12 Sept, 2025",
    statusLevel: "Reviewed by ACR",
    caseCategoryId: 1,
  },
  {
    id: 3,
    suitNumber: "ID/3885GCM/2025",
    caseTitle: "State of Lagos vs Salman Lukman",
    type: "Writ of fifa",
    judgementDate: "12 Sept, 2025",
    statusLevel: "Reviewed by ACR",
    caseCategoryId: 1,
  },
  {
    id: 4,
    suitNumber: "ID/3885GCM/2025",
    caseTitle: "State of Lagos vs Salman Lukman",
    type: "Writ of fifa",
    judgementDate: "12 Sept, 2025",
    statusLevel: "Reviewed by ACR",
    caseCategoryId: 1,
  },
  {
    id: 5,
    suitNumber: "ID/3885GCM/2025",
    caseTitle: "State of Lagos vs Salman Lukman",
    type: "Writ of fifa",
    judgementDate: "12 Sept, 2025",
    statusLevel: "Reviewed by ACR",
    caseCategoryId: 1,
  },
  {
    id: 6,
    suitNumber: "ID/3885GCM/2025",
    caseTitle: "State of Lagos vs Salman Lukman",
    type: "Writ of fifa",
    judgementDate: "12 Sept, 2025",
    statusLevel: "Reviewed by ACR",
    caseCategoryId: 1,
  },
];

const ChiefJudgePostJudgement = () => {
  const { frequentData } = useContext(ShareContext);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const onPagePick = (pick) => {
    setPageIndex(pick.id - 1);
  };

  const onSearch = () => {};

  return (
    <div>
      <CustomSearchSortHeader
        onSearch={onSearch}
        frequentData={frequentData}
        isSearchAndDateOnly
      />

      <div className="exportdiv">
        <img src={wordicon} style={{ cursor: "pointer" }} />
        <img src={excelicon} style={{ cursor: "pointer" }} />
        <img src={pdficon} style={{ cursor: "pointer" }} />
      </div>

      <div className="tab_view">
        {judgePostJudgementCases?.length === 0 && <JisEmptyList />}
        {judgePostJudgementCases?.length > 0 && (
          <div className="table">
            <div className="section-cases">
              <span>Warrant of Execution</span>
            </div>
            <div className="table-wrapper">
              <table className="case-table">
                <thead>
                  <tr>
                    <th className="col-title">Suit Number</th>
                    <th className="col-title">Case Title</th>
                    <th>Type</th>
                    <th className="col-medium">Judgement Date</th>
                    <th className="col-medium">Status level</th>
                    <th className="col-title">Details</th>
                    <th className="col-action">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {judgePostJudgementCases?.map((caseItem, index) => (
                    <tr key={index}>
                      <td>{caseItem.suitNumber}</td>
                      <td>{caseItem.caseTitle}</td>
                      <td>{caseItem.type}</td>
                      <td>{displayDate(caseItem.judgementDate)}</td>
                      <td>{caseItem.statusLevel}</td>
                      <td>
                        <JisButton variant="plain">View</JisButton>
                      </td>
                      <td>
                        <JisButton variant="plain">Process</JisButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <Pagenated
              onChangePageSize={(k) => setPageSize(k)}
              size={pageSize}
              total={judgePostJudgementCases.length}
              maxPage={20}
              onPick={onPagePick}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ChiefJudgePostJudgement;
